import { FieldInputProps, FormikState } from "formik";
import React, { useMemo } from "react";
import classNames from "../../utils/classNames";

interface Props {
  className?: string;
  id?: string;
  field: FieldInputProps<any>;
  form: FormikState<any>;
  label?: string;
  helperText?: string;
  disabled?: boolean;
}

const Checkbox: React.FC<Props> = ({
  className,
  id,
  field,
  form,
  label,
  helperText,
  disabled = false,
  children,
  ...otherProps
}) => {
  const checkboxProps = useMemo(
    () => ({
      id: id || field.name,
      disabled,
      ...field,
      ...otherProps,
      type: "checkbox",
      checked: !!field.value
    }),
    [disabled, field, id, otherProps]
  );

  return (
    <div className={classNames("mt-6", className)}>
      <div className="flex gap-4 h-full items-center">
        <div className=" flex-shrink-0 max-w-lg flex h-full">
          <input
            className={classNames(
              "block px-3 py-2 border-gray-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5 focus:outline-none h-4 w-4 self-center",
              !disabled && "cursor-pointer"
            )}
            {...checkboxProps}
          />
        </div>

        {label && (
          <label
            htmlFor={id || field.name}
            className={classNames(
              "flex-1 text-sm font-medium leading-5 text-gray-900 dark:text-white mt-px",
              !disabled && "cursor-pointer"
            )}
          >
            {label}
          </label>
        )}
      </div>

      {helperText && (
        <p className="mt-2 text-xs text-right text-gray-600 dark:text-gray-300">
          {helperText}
        </p>
      )}
    </div>
  );
};

export default Checkbox;
